import React from 'react';
import GlobalContext from '../../GlobalContext';
import QuoteRequestForm, { BrochureBtn, VideoButton } from '../../BFComponents';

const CanonC910 = () => {
    const  paths =GlobalContext().paths;
    return (
        <div className="container">
            <div className="row">
                <div className="col-md-3 p-4">
                    <img src={paths.pictures + "c910.svg"}></img>
                </div>
            </div>
            <img className="img-100" src={paths.pictures + "c910.jpg"}></img>
            <h3 className=" mt-4">REAP THE BENEFITS OF PRODUCTIVITY, VERSATILITY, AND HIGH QUALITY</h3>
            <div className="row">
                <div className="col-md-7">
                    <p>The imagePRESS C910 Series is a true, light- to mid-volume
                    production press that incorporates advanced technologies to help
                    print establishments achieve amazing results—all in a small footprint.
                    Incorporated into this color digital press is Canon’s passion and
                    unique understanding of imaging, photography, color science, and
                    workflow. This expertise has resulted in a high-quality digital press
                    that’s both productive and versatile for printing establishments of
varying shapes and sizes.</p>
                </div>
                <div className="col-md-5">
                    <QuoteRequestForm source={window.location} />
                    <BrochureBtn brochure={"Canon imagePRESS-C910-Brochure.pdf"} />
                </div>
            </div>

            <div className="row mt-4">
                <div className="col-md-4">
                    <h5>Outstanding Productivity</h5>
                    <ul>
                        <li>Production speeds of up to 90 ipm</li>
                        <li>Maintains rated speed on uncoated
stocks up to 80 lb. Cover</li>
                        <li>7,650-sheet1 feeding capacity with
up to six different sources.</li>
                        <li>Wide array of productive Canon and
third-party in-line accessories.</li>
                    </ul>
                </div>
                <div className="col-md-4">
                    <h5>Amazing Quality</h5>
                    <ul>
                        <li> 2400 x 2400-dpi print resolution
                        utilizing the unique R-VCSEL
imaging technology</li>
                        <li>Intuitive calibration process that
                        uses internal sensors to measure
test patches</li>
                        <li> Translucent CV Toner produces vibrant
images on a wide variety of stocks</li>
                        <li>Multi D.A.T. helps to achieve
                        consistent color across long runs
automatically</li>
                    </ul></div>
                <div className="col-md-4">
                    <h5>Brilliant Versatility</h5>
                    <ul>
                        <li>Supports stocks up to 130 lb. Cover</li>
                        <li>Runs a variety of envelopes and long
sheets2 up to 51.2"</li>
                        <li>Helps achieve highly accurate and
                        consistent registration, even on large
and heavy stocks</li>
                        <li>Meets ENERGY STAR® standards
and rated EPEAT Gold</li>
                    </ul></div>
            </div>

            <div className="row">
                <div className="col-md-4">
                    <VideoButton id={"V5gvSvFh6NF4"} />
                </div>
                <div className="col-md-4">
                    <VideoButton id={"VxUrTzGRYnFg"} />
                </div>
                <div className="col-md-4">
                    <VideoButton id={"Vz35ELHuxfkw"} />
                </div>

            </div>


        </div>
    )
}

export default CanonC910;